type Props = {
  label?: string;
};

export const LoadingOverlay = ({ label = 'Preparing classroom...' }: Props) => (
  <div className="absolute inset-0 z-40 flex flex-col items-center justify-center bg-background-main/70">
    <div className="h-10 w-10 animate-spin rounded-full border-2 border-background-border border-t-brand" />
    <p className="mt-4 text-sm text-text-primary">{label}</p>
  </div>
);

